import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import {
  getAllAuthors,
  createNewAuthor,
  editAuthor,
  assignAuthortoContent,
  unAssignAuthortoContent,
  deleteAuthor,
  getAuthorById,
  getAuthorsAsDataTable,
  getAuthorsLookUps,
  getContentEntityAuthors,
  addAuthorByIdForHistory,
  getAuthorsToBeExported,
  getAuthorByIdMultilingual,
  createAuthorMultilingual,
  editAuthorMultilingual,
} from './thunks';
import { AuthorsState } from './types';

export const name = 'authors';

const initialState: AuthorsState = {
  data: [],
  detailsHistory: [],
  details: null,
  dataTableData: null,
  exportData: null,
  lookups: null,
  selectedContentAuthors: [],
  status: 'idle',
  updatingStatus: 'idle',
  datatableStatus: 'idle',
  lookupsStatus: 'idle',
  assignStatus: 'idle',
  selectedContenrAuthorsStatus: 'idle',
  exportDataStatus: 'idle',
  byIdMultilingual: {
    data: null,
    status: 'idle',
  },
  createMultilingual: {
    data: null,
    status: 'idle',
  },
  editMultilingual: {
    data: null,
    status: 'idle',
  },
};

export const getAllAuthorsAsync = createAsyncThunk(
  name + '/getAllAuthors',
  getAllAuthors
);
export const createNewAuthorAsync = createAsyncThunk(
  name + '/createNewAuthor',
  createNewAuthor
);
export const editAuthorAsync = createAsyncThunk(
  name + '/editAuthor',
  editAuthor
);
export const assignAuthortoContentAsync = createAsyncThunk(
  name + '/assignAuthortoContent',
  assignAuthortoContent
);
export const unAssignAuthortoContentAsync = createAsyncThunk(
  name + '/unAssignAuthortoContent',
  unAssignAuthortoContent
);
export const deleteAuthorAsync = createAsyncThunk(
  name + '/deleteAuthor',
  deleteAuthor
);
export const getAuthorByIdAsync = createAsyncThunk(
  name + '/getAuthorById',
  getAuthorById
);
export const addAuthorByIdForHistoryAsync = createAsyncThunk(
  name + '/addAuthorByIdForHistory',
  addAuthorByIdForHistory
);
export const getAuthorsAsDataTableAsync = createAsyncThunk(
  name + '/getAuthorsAsDataTable',
  getAuthorsAsDataTable
);
export const getAuthorsLookUpsAsync = createAsyncThunk(
  name + '/getAuthorsLookUps',
  getAuthorsLookUps
);
export const getContentEntityAuthorsAsync = createAsyncThunk(
  name + '/getContentEntityAuthors',
  getContentEntityAuthors
);

export const getAuthorsToBeExportedAsync = createAsyncThunk(
  name + '/getAuthorsToBeExported',
  getAuthorsToBeExported
);

export const getAuthorByIdMultilingualAsync = createAsyncThunk(
  name + '/getAuthorByIdMultilingual',
  getAuthorByIdMultilingual
);

export const createAuthorMultilingualAsync = createAsyncThunk(
  name + '/createAuthorMultilingual',
  createAuthorMultilingual
);

export const editAuthorMultilingualAsync = createAsyncThunk(
  name + '/editAuthorMultilingual',
  editAuthorMultilingual
);

export const slice = createSlice({
  name: name,
  initialState,
  reducers: {
    clear: () => {
      return initialState;
    },
    clearDetails: (state) => {
      state.details = null;
    },
    clearLookups: (state) => {
      state.lookups = null;
    },
    clearDataTableData: (state) => {
      state.dataTableData = null;
    },
    clearSelectedContentAuthors: (state) => {
      state.selectedContentAuthors = [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllAuthorsAsync.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(getAllAuthorsAsync.fulfilled, (state, action) => {
        state.status = 'idle';
        state.data = action.payload;
      })
      .addCase(getAllAuthorsAsync.rejected, (state) => {
        state.status = 'failed';
      })
      .addCase(getAuthorByIdAsync.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(getAuthorByIdAsync.fulfilled, (state, action) => {
        state.status = 'idle';
        state.details = action.payload;
      })
      .addCase(getAuthorByIdAsync.rejected, (state) => {
        state.status = 'failed';
      })
      .addCase(addAuthorByIdForHistoryAsync.fulfilled, (state, action) => {
        return {
          ...state,
          detailsHistory: [...state.detailsHistory, action.payload],
        };
      })
      .addCase(getAuthorsAsDataTableAsync.pending, (state) => {
        state.datatableStatus = 'loading';
      })
      .addCase(getAuthorsAsDataTableAsync.fulfilled, (state, action) => {
        state.datatableStatus = 'idle';
        state.dataTableData = action.payload;
      })
      .addCase(getAuthorsAsDataTableAsync.rejected, (state) => {
        state.datatableStatus = 'failed';
      })
      .addCase(getAuthorsLookUpsAsync.pending, (state) => {
        state.lookupsStatus = 'loading';
      })
      .addCase(getAuthorsLookUpsAsync.fulfilled, (state, action) => {
        state.lookupsStatus = 'idle';
        state.lookups = action.payload;
      })
      .addCase(getAuthorsLookUpsAsync.rejected, (state) => {
        state.lookupsStatus = 'failed';
      })
      .addCase(createNewAuthorAsync.pending, (state) => {
        state.updatingStatus = 'loading';
      })
      .addCase(createNewAuthorAsync.fulfilled, (state) => {
        state.updatingStatus = 'idle';
      })
      .addCase(createNewAuthorAsync.rejected, (state) => {
        state.updatingStatus = 'failed';
      })
      .addCase(editAuthorAsync.pending, (state) => {
        state.updatingStatus = 'loading';
      })
      .addCase(editAuthorAsync.fulfilled, (state) => {
        state.updatingStatus = 'idle';
      })
      .addCase(editAuthorAsync.rejected, (state) => {
        state.updatingStatus = 'failed';
      })
      .addCase(assignAuthortoContentAsync.pending, (state) => {
        state.assignStatus = 'loading';
      })
      .addCase(assignAuthortoContentAsync.fulfilled, (state) => {
        state.assignStatus = 'idle';
      })
      .addCase(assignAuthortoContentAsync.rejected, (state) => {
        state.assignStatus = 'failed';
      })
      .addCase(unAssignAuthortoContentAsync.pending, (state) => {
        state.assignStatus = 'loading';
      })
      .addCase(unAssignAuthortoContentAsync.fulfilled, (state) => {
        state.assignStatus = 'idle';
      })
      .addCase(unAssignAuthortoContentAsync.rejected, (state) => {
        state.assignStatus = 'failed';
      })
      .addCase(getContentEntityAuthorsAsync.pending, (state) => {
        state.selectedContenrAuthorsStatus = 'loading';
      })
      .addCase(getContentEntityAuthorsAsync.fulfilled, (state, action) => {
        state.selectedContenrAuthorsStatus = 'idle';
        state.selectedContentAuthors = action.payload;
      })
      .addCase(getContentEntityAuthorsAsync.rejected, (state) => {
        state.selectedContenrAuthorsStatus = 'failed';
      })
      .addCase(getAuthorsToBeExportedAsync.pending, (state) => {
        state.exportDataStatus = 'loading';
      })
      .addCase(getAuthorsToBeExportedAsync.fulfilled, (state, action) => {
        state.exportDataStatus = 'idle';
        state.exportData = action.payload;
      })
      .addCase(getAuthorsToBeExportedAsync.rejected, (state) => {
        state.exportDataStatus = 'failed';
      })
      .addCase(getAuthorByIdMultilingualAsync.pending, (state) => {
        state.byIdMultilingual.status = 'loading';
      })
      .addCase(getAuthorByIdMultilingualAsync.fulfilled, (state, action) => {
        state.byIdMultilingual = {
          data: action.payload,
          status: 'idle',
        };
      })
      .addCase(getAuthorByIdMultilingualAsync.rejected, (state) => {
        state.byIdMultilingual.status = 'failed';
      })
      .addCase(createAuthorMultilingualAsync.pending, (state) => {
        state.createMultilingual.status = 'loading';
      })
      .addCase(createAuthorMultilingualAsync.fulfilled, (state, action) => {
        state.createMultilingual = {
          data: action.payload,
          status: 'idle',
        };
      })
      .addCase(createAuthorMultilingualAsync.rejected, (state) => {
        state.createMultilingual.status = 'failed';
      })
      .addCase(editAuthorMultilingualAsync.pending, (state) => {
        state.editMultilingual.status = 'loading';
      })
      .addCase(editAuthorMultilingualAsync.fulfilled, (state, action) => {
        state.editMultilingual = {
          data: action.payload,
          status: 'idle',
        };
      })
      .addCase(editAuthorMultilingualAsync.rejected, (state) => {
        state.editMultilingual.status = 'failed';
      });
  },
});

export const actions = slice.actions;

export default slice.reducer;
